import React from 'react';

import Divider, { DividerColorScheme } from '../Divider';
import HeadlineDivider from '../HeadlineDivider';
import { HeadlineDividerVariant } from '../HeadlineDivider/HeadlineDivider';
import { HeroContentPosition, HeroTitleVariant } from './index';

interface HeroTitleProps {
  color?: string;
  position: HeroContentPosition;
  variant?: HeroTitleVariant;
}

const HeroTitle: React.FC<HeroTitleProps> = ({
  color,
  position,
  variant = 'divider',
  children,
}) => {
  if (variant === 'divider') {
    let colorScheme;
    if (color === 'white') {
      colorScheme = DividerColorScheme.WHITE;
    } else {
      colorScheme = DividerColorScheme.BLUE;
    }

    return (
      <Divider
        as="h2"
        colorScheme={colorScheme}
        flexBasis={0}
        fontSize="12px"
        marginTop={{ md: '8px' }}
        paddingTop={2}
        paddingBottom={2}
      >
        {children}
      </Divider>
    );
  }

  let headlineVariant = HeadlineDividerVariant.lightShort;
  if (color !== 'white') {
    headlineVariant = HeadlineDividerVariant.short;
  }
  return (
    <HeadlineDivider
      variant={headlineVariant}
      as="h2"
      flexBasis={0}
      fontSize="12px"
      marginTop="8px"
      marginBottom="8px"
      paddingTop={2}
      paddingBottom={2}
    >
      {children}
    </HeadlineDivider>
  );
};

export default HeroTitle;
